import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { getHomeParagraph } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import CustomTable from "../../Common/DataTable/DataTable";

export default function ParagraphView() {

  const { id, partnerId } = useParams();

  const [paragraph, setParagraph] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchParagraphData = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }
    
    try {
      const response = await getHomeParagraph(id);
      setParagraph(response.data.data[0]);
    } catch (error) {
     showToast({
      type: 'error',
      message: error.response.data.message || 'Failed to fetch paragraph data. Please try again.',
     });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchParagraphData();
  }, [id]);

  const columns = ["Paragraph Image", "Paragraph"];
  const rows = [];

  if (paragraph && Object.keys(paragraph).length > 0) {
    rows.push([
      paragraph.paragraph_image ? <img src={paragraph.paragraph_image} alt="slider 1" width="350" height="auto" /> : null,
      paragraph.paragraph
    ]);
  }
  return (
    <>
    {isLoading ? <CmsCircularProgress/> :  <ContentWrapper>
      <HomeTitle>Paragraph Section</HomeTitle>
      <CustomTable
          columns={columns}
          rows={rows}
          isLoading={isLoading}
        />
      <ButtonWrapper>
        <Link to={`/${partnerId}/home`}>
          <Button variant="secondary">Go Back</Button>
        </Link>
        <Link to={`/${partnerId}/home/paragraph/edit/${id}`}>
          <Button>{Number(id) ? 'Edit' : 'Add'} paragraph section</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>}
    </>
  );
}

const ContentWrapper = styled.div`
 @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;



const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 5rem;
  justify-content: center;
      @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
    gap: 1rem;
  }
`;
